import React, { Component } from 'react';
import { Box, Grommet } from 'grommet';
import MUIDataTable from "mui-datatables";
import '../index.css'
import CustomToolbar from './CustomToolbar'
import moment from 'moment';

class MUICustomTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      title: this.props.popUptitle,
      isEdit: false,
      poptitle: this.props.popUpEdittitle,
      type: this.props.type
    };
  }

  render() {
    const { title, poptitle, visible } = this.state;
    const { data, columns } = this.props;
    const options = {
      filterType: "dropdown",
      selectableRows: "none",
      onDownload: (buildHead, buildBody, columns, data) => {
        const offset = moment().utcOffset();
        const formattedData = data.map(row => ({
          ...row,
          data: row.data.map(val => {
            if (typeof val === 'number' && val > 1e12) {
              return moment(val).utcOffset(offset).format('YYYY-MM-DD HH:mm:ss ZZ');
            }
            if (typeof val === 'string' && /<[^>]+>/.test(val)) {
              return val.replace(/<[^>]+>/g, '').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;/g, ' ').trim();
            }
            return val;
          })
        }));
        return '\uFEFF' + buildHead(columns) + buildBody(formattedData);
      },
      customToolbar: () => {
        return (
          <CustomToolbar
            popUptitle={title}
            popUpEdittitle={poptitle}
            visible={visible}
            {...this.props}
          />
        )
      }
    };

    return (
      <Grommet>
        <Box pad="xsmall" basis="xsmall" width="1388px" fill="vertical">
          <MUIDataTable
            title={title}
            data={data}
            columns={columns}
            options={options}
          />
        </Box>
      </Grommet>

    )
  }
}

export default MUICustomTable
